export default "__VITE_ASSET__XehsXfi0__"